import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actionCreators } from '@/checkout-instore-legacy/returnExchange/actions'

import OrderIdentifier from '../components/OrderIdentifier'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

const mapStateToProps = (state) => ({
  errors: state.returnExchange.errors,
  orderId: state.returnExchange.orderId,
  order: state.returnExchange.order,
  orderLoading: state.returnExchange.orderLoading,
})

export default connect(mapStateToProps, mapDispatchToProps)(OrderIdentifier)
